import InvestorDashContent from './investor-dash-content';

export default InvestorDashContent;
